<template>
    <v-btn class="primepulsing btn-df text-none rounded100" :class="{pulsing: !noblink}" >
        <v-icon left medium>
            mdi-cart-arrow-down
        </v-icon>
        <span v-if="total > 0 && !$store.getters.hidePrices">{{total | priceTotal}}</span>
        <span v-else>In den Korb</span>
    </v-btn>
<!--    <div class="btnLink btn-shadow" :class="{greenPulsing: total > 0 && !noblink}">-->
<!--        <table class="table-collapse myTable">-->
<!--            <tr>-->
<!--                <td class="a" v-if="!small">-->
<!--                    <v-icon medium :dark="true">mdi-cart-arrow-down</v-icon>-->
<!--                </td>-->
<!--                <td class="b" v-if="total > 0">-->
<!--                    <span>{{total | priceTotal}}</span>-->
<!--                </td>-->
<!--                <td class="b" v-else>-->
<!--&lt;!&ndash;                    <span v-if="small">ZUM WARENKORB</span>&ndash;&gt;-->
<!--                    <h3>In den Korb</h3>-->
<!--                </td>-->
<!--            </tr>-->
<!--        </table>-->
<!--    </div>-->
</template>

<script>
    export default {
        name: "AddToCartButton",
        props: {
            total: {
                default: 0,
                type: Number
            },
            noblink: {
                default: false,
                type: Boolean
            },
            small: {
                default: false,
                type: Boolean
            }
        },

    }
</script>

<style lang="scss" scoped>
    /*@import '../styles/base';*/

    /*.vdevice-not-xs .btn-df ::v-deep .v-btn__content{*/
    /*    font-size: 1.5rem;*/
    /*}*/

    /*.device-xs{*/
    /*    .myTable {*/
    /*        td {*/
    /*            padding: 0 6px;*/
    /*        }*/
    /*    }*/

    /*    .b {*/
    /*        font-size: 1.4em;*/
    /*    }*/
    /*}*/
</style>
